import React from 'react';
export default (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    fill="currentColor"
  >
    <style type="text/css">
      {'.st0{fill-rule:evenodd;clip-rule:evenodd;}'}
    </style>
    <path
      className="st0"
      d="M2,11.2c0-4.5,4.5-8.1,10-8.1c5.5,0,10,3.6,10,8.1c0,4.5-4.5,8.1-10,8.1c-1.5,0-2.9-0.3-4.2-0.8
		c-1,0.8-2.9,2-5.5,2c-0.1,0-0.2-0.1-0.3-0.2C2,20.3,2,20.1,2.1,20c0,0,1.7-1.8,2.1-3.7C2.8,14.9,2,13.1,2,11.2z M12.4,8
		c-0.2-0.4-0.8-0.4-0.9,0L11,9.6c-0.1,0.2-0.3,0.3-0.5,0.3l-1.7,0c-0.5,0-0.7,0.6-0.3,0.9l1.3,1c0.2,0.1,0.2,0.3,0.2,0.5L9.6,14
		c-0.1,0.5,0.4,0.8,0.8,0.6l1.4-1c0.2-0.1,0.4-0.1,0.6,0l1.4,1c0.4,0.3,0.9-0.1,0.8-0.6l-0.5-1.6c-0.1-0.2,0-0.4,0.2-0.5l1.3-1
		c0.4-0.3,0.2-0.9-0.3-0.9l-1.7,0c-0.2,0-0.4-0.1-0.5-0.3L12.4,8z"
    />
  </svg>
);
